import { call, put } from 'redux-saga/effects'
import VideoIntegration from 'Redux/VideoIntegrationRedux'
import { BuildErrorMsg } from './ApiHelpers'

export function * onVideoJwPushRequest (api, action) {
  const resp = yield call(api.pushToJw, action.id, action.jwPushParams)
  if (resp.ok) {
    yield put(VideoIntegration.videoJwPushSuccess(resp.data))
  } else {
    yield put(VideoIntegration.videoJwPushFailure(BuildErrorMsg(resp)))
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/VideoIntegrationSagas.js